var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.462 12.4794C23.462 18.5452 18.5448 23.4624 12.4791 23.4624C6.41334 23.4624 1.49609 18.5452 1.49609 12.4794C1.49609 6.41367 6.41334 1.49643 12.4791 1.49643C18.5448 1.49643 23.462 6.41367 23.462 12.4794Z",
    stroke: "#FA3333",
    strokeWidth: 2.74574
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 6.98792V13.1658",
    stroke: "#FA3333",
    strokeWidth: 2.74574,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8532 17.2845C13.8532 18.0427 13.2385 18.6573 12.4803 18.6573C11.7221 18.6573 11.1074 18.0427 11.1074 17.2845C11.1074 16.5262 11.7221 15.9116 12.4803 15.9116C13.2385 15.9116 13.8532 16.5262 13.8532 17.2845Z",
    fill: "#FA3333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.230101c85b83d90e1d2a88b0c32e581a.svg";
export { ForwardRef as ReactComponent };